import { render, staticRenderFns } from "./NewFinish.vue?vue&type=template&id=57f3e7cb"
import script from "./NewFinish.vue?vue&type=script&lang=js"
export * from "./NewFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports